// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1610":"7d926efc","2466":"7d926efc","5464":"7d926efc","5907":"7d926efc","9013":"7d926efc"}[chunkId] + ".chunk.css";
};